export default __webpack_public_path__ + "static/media/threesteps2.80a2105e.jpg";